import React from "react";
import classnames from "classnames";
import css from "./Content.module.scss";

type ContentProps = React.PropsWithChildren<{
  withInner?: boolean;
  narrow?: boolean;
  noPadding?: boolean;
}>;

export const Content: React.FC<ContentProps> = ({ children, withInner = false, narrow = false, noPadding = false }) => {
  const withInnerComponent = (
    <div
      className={classnames([
        css.content,
        {
          [css.padding]: !noPadding,
        },
      ])}
    >
      <div className={css.inner}>{children}</div>
    </div>
  );

  const withoutInnerComponent = (
    <div
      className={classnames([
        css.content,
        {
          [css.narrow]: narrow,
          [css.padding]: !noPadding,
        },
      ])}
    >
      {children}
    </div>
  );

  return withInner ? withInnerComponent : withoutInnerComponent;
};
